<script lang="ts">
    import {Component, Prop, toNative} from 'vue-facing-decorator'
    import {CompanyTypeToCommunicationInfoType} from '~/utils/api-data-mapings'
    import __ClientAutocomplete, {
        ClientAutocomplete as _ClientAutocomplete,
    } from '~/components/account/modals/newOrderRequest/ClientAutocomplete.vue'

    @Component({mixins: [__ClientAutocomplete]})
    export class PrivateClientAndCompaniesAutocomplete extends _ClientAutocomplete {
        @Prop({default: () => [], type: Array}) relationship
        @Prop({default: false, type: Boolean}) communicationsMode

        cancelTokenSources = []

        async loadPrivateClients() {
            try {
                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                const rqPClients = {
                    pattern: this.searchInput,
                    limit: 10,
                    active: true,
                }

                return await this.$api.suggestPrivateClients.get(rqPClients, cancelTokenSource.token)
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            }
        }

        async loadCompanies(rq) {
            try {
                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                return await this.$api.companies.get(rq, cancelTokenSource.token)
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            }
        }

        async loadClients() {
            try {
                this.clients = []
                this.cancelTokenSources.forEach(cancelTokenSource => cancelTokenSource.cancel())
                this.cancelTokenSources = []
                this.isLoadingClients = true

                const companyRequests = this.relationship.map(relationship => ({
                    name: this.searchInput,
                    limit: 10,
                    order: 'ALPHABET',
                    ascending: true,
                    active: true,
                    ...(relationship && {relationship}),
                }))

                const [{persons}, ...rs] = await Promise.all([
                    this.loadPrivateClients(),
                    ...companyRequests.map(rq => this.loadCompanies(rq)),
                ])

                this.clients = [
                    ...persons.map(p => ({...p, id: p.personId})),
                    ...rs.map(({companies}) => companies).flat(),
                ]
            } catch (e) {
                /* empty */
            } finally {
                this.isLoadingClients = false
            }
        }

        inputText(entry, selected = null, noPrefix = false) {
            const prefix = entry.prefix && !noPrefix ? entry.prefix : ''
            const firstName = entry.firstName ? entry.firstName : ''
            const lastName = entry.lastName ? entry.lastName : ''
            const companyName = entry.name

            let label = companyName
                ? companyName
                : (prefix ? `${prefix}. ` : '') + (firstName ? `${firstName} ` : '') + (lastName ? `${lastName}` : '')

            if (this.communicationsMode) {
                label += entry.type
                    ? ` (${this.$t(`accountType.${CompanyTypeToCommunicationInfoType(entry.type)}`)})`
                    : ` (${this.$t('private_clients')})`
            }

            return label
        }
    }

    export default {...toNative(PrivateClientAndCompaniesAutocomplete), ssrRender: __ClientAutocomplete.ssrRender}
</script>
